import React, {useState, useEffect} from 'react';
import './videoSliderComponent.css';
const VideoSliderComponent = (props) => {
  const [thumbLeft, setThumbLeft] = useState(props.progressValue || 0);

  const sliderChange = (evt) => {
    setThumbLeft(
      evt.target.value === 0 ? evt.target.value : evt.target.value - 2 + '%',
    );
    props.setProgress && props.setProgress(evt.target.value);
  };
  useEffect(() => {
    setThumbLeft(
      props.progressValue === 0
        ? props.progressValue
        : props.progressValue - 2 + '%',
    );
  }, [props.progressValue]);
  return (
    <div className="et-vpc-progress-wrapper">
      <div className="et-vpc-progress-container">
        {/* <div className="et-vpc-progress-progress-container"></div> */}
        <div
          className="et-vpc-progress-slider-track"
          style={{width: thumbLeft}}></div>
        <div className="et-vpc-progress-slider-thumb" style={{left: thumbLeft}}>
          {' '}
        </div>
        <input
          className="et-vpc-progress-input"
          type="range"
          onChange={sliderChange}
          max={props.maxProgress}></input>
      </div>
    </div>
  );
};

export default VideoSliderComponent;
